(() => {
  const source = document.currentScript;
  if (!source || window.peakPreorderMonthRepair) return;
  window.peakPreorderMonthRepair = true;
  const names = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const cutoff = source.dataset.peakMonthCutoff;
  const cacheKey = `peak-preorder-months-v3:${cutoff}:${new URL(location.href).searchParams.get('preview_theme_id') || 'live'}`;
  const validDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(Date.parse(`${value}T12:00:00Z`));
  function expiredMonths(products) {
    const groups = new Map();
    for (const p of products) {
      const name = names.find(n => n.toLowerCase() === String(p.month || '').trim().toLowerCase());
      if (!name) continue;
      if (!groups.has(name)) groups.set(name, []);
      groups.get(name).push(p);
    }
    return [...groups].filter(([name, items]) => {
      const month = names.indexOf(name) + 1;
      const currentYear = Number(cutoff.slice(0,4)), currentMonth = Number(cutoff.slice(5,7));
      return items.length && items.every(p => {
        const year = validDate(p.date) ? Number(p.date.slice(0,4)) : currentYear + (currentMonth - month > 6 ? 1 : 0);
        return `${year}-${String(month).padStart(2,'0')}` < cutoff;
      });
    }).map(([name]) => name);
  }
  function apply(expired) {
    for (const name of expired) {
      document.querySelectorAll('[data-peak-preorder-month]').forEach(li => {
        if (li.dataset.peakPreorderMonth === name) { li.hidden = true; li.style.display = 'none'; }
      });
      document.querySelectorAll('.collection-list__item .collection-card__title').forEach(a => {
        const url = new URL(a.href, location.href);
        if (url.pathname !== `/collections/${name.toLowerCase()}-pre-orders`) return;
        const li = a.closest('.collection-list__item');
        if (li) { li.hidden = true; li.style.display = 'none'; }
      });
    }
    document.querySelectorAll('.peak-month-pending').forEach(node => node.classList.remove('peak-month-pending'));
    window.dispatchEvent(new Event('resize'));
  }
  async function readAll() {
    const rows = [], seen = new Set();
    let page = 1, pages = 1, total = 0;
    do {
      const url = new URL(source.dataset.peakMonthSource, location.origin);
      url.searchParams.set('view', 'peak-release-calendar');
      url.searchParams.set('page', String(page));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Release month data unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector('#peak-release-calendar-data');
      if (!node) throw new Error('Release month data missing');
      const data = JSON.parse(node.textContent);
      if (data.page !== page || !Number.isInteger(data.pages) || !Number.isInteger(data.total) || !Array.isArray(data.products)) throw new Error('Incomplete release month page');
      pages = data.pages; total = data.total;
      for (const p of data.products) if (!seen.has(p.id)) { seen.add(p.id); rows.push({id:p.id, month:p.month, date:p.date}); }
      page++;
    } while (page <= pages);
    if (rows.length !== total) throw new Error('Release catalogue changed during loading');
    return expiredMonths(rows);
  }
  async function start() {
    if (!/^\d{4}-\d{2}$/.test(cutoff || '')) { apply([]); return; }
    try {
      let cached;
      try { cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null'); } catch (_) {}
      if (cached && Date.now() - cached.savedAt < 300000 && Array.isArray(cached.expired)) { apply(cached.expired); return; }
      const expired = await readAll();
      apply(expired);
      try { sessionStorage.setItem(cacheKey, JSON.stringify({savedAt:Date.now(), expired})); } catch (_) {}
    } catch (_) {
      document.documentElement.dataset.peakMonthStatus = 'incomplete';
      apply([]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
